export default function ExpandImage(src: string) {

    var children = window.open("", "_blank");
    var img = children.document.createElement("img");
    img.src = src;
    children.document.body.appendChild(img);
    children.document.body.style.textAlign = "center";
    children.document.body.style.margin = "auto";
}